/**
 * Render oncesi/sonrasi tek seferlik is kuyrugu sistemi.
 *
 * `addBefore` / `addAfter` ile kaydedilen callback'ler ilgili fazda (beforeRender
 * / afterRender) calistirilir; `dispose: true` olanlar calistiktan sonra
 * listeden dusurulur (tek seferlik). Engine sadece addBeforeRequest/
 * addAfterRequest yuzeyini buraya delege eder.
 */
import type { EngineRequest } from "../EngineRequest";
import type { EngineSystem, FramePhase } from "../runtime/EngineSystem";

export class RequestQueueSystem implements EngineSystem {
  readonly name = "requests";
  readonly labels: Partial<Record<FramePhase, string>> = {
    beforeRender: "onBeforeRender",
    afterRender: "onAfterRender",
  };

  private _before: EngineRequest[] = [];
  private _after: EngineRequest[] = [];

  addBefore(req: EngineRequest): void {
    this._before.push(req);
  }

  addAfter(req: EngineRequest): void {
    this._after.push(req);
  }

  beforeRender(): void {
    this._before.forEach((req) => req.callback());
    this._before = this._before.filter((req) => !req.dispose);
  }

  afterRender(): void {
    this._after.forEach((req) => req.callback());
    this._after = this._after.filter((req) => !req.dispose);
  }
}
